import { ActionTypes } from "../constantes/ActionTypes";

const initialState = {
  data: [],
  isLoading: false,
  error: "",
};
export const SoldeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.ACTION_SOLDE_INIT:
      return initialState;
    case ActionTypes.ACTION_SOLDE_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.ACTION_SOLDE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case ActionTypes.ACTION_SOLDE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
